import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import {
  getProfileService,
  updateProfileService,
} from "../../../services/profileServices";
import { AiFillEdit } from "react-icons/ai";
import TextField from "../../Form/TextField";
import CountryField from "../../Form/CountryField";
import errorModel from "../../Errors/ErrorModel";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { rootContexts } from "../../../contexts/rootContexts";
export default function EditProfileSection() {
  const [asPresonalInfoEdit, setAsPersonalInfoEdit] = useState(false);

  const { asLoading, setAsLoading } = useContext(rootContexts);
  const formik = useFormik({
    initialValues: {
      fname: "",
      lname: "",
      email: "",
      gender: "",
      country: "",
      role: "User",
    },
    onSubmit: async (values) => {
      const profileData = await updateProfileService(values);
      console.log("theprofile data", profileData);
      if (profileData.status === true) {
        setAsPersonalInfoEdit(false);
        errorModel("sucess", profileData.message);
      } else {
        errorModel("error", profileData.message);
      }
    },
  });
  const profileData = async () => {
    const result = await getProfileService();

    if (result.account) formik.setValues(result.account);
    setAsLoading(false);

    // setData(account)
  };
  useEffect(() => {
    profileData();
    setAsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h1 className="h1">Profile</h1>
      {asLoading ? (
        <Skeleton className="h-[200px] " duration={1.5} />
      ) : (
        <div>
          <div className="flex items-center justify-between">
            <h1 className="h2">Personal Information</h1>
            <div>
              {asPresonalInfoEdit ? (
                <div className="flex items-center gap-x-3">
                  <button
                    className="btn-danger-outline !text-[12px]"
                    onClick={() => {
                      setAsPersonalInfoEdit(!asPresonalInfoEdit);
                      profileData();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    form="profileForm"
                    className="btn-sucess !text-[12px]"
                  >
                    Save
                  </button>
                </div>
              ) : (
                <button
                  className="btn-primary !text-[12px]"
                  onClick={() => setAsPersonalInfoEdit(!asPresonalInfoEdit)}
                >
                  <AiFillEdit />
                  Edit
                </button>
              )}
            </div>
          </div>
          <div className="mt-2 border-2 border-beta p-4 rounded-md">
            <form id="profileForm" onSubmit={formik.handleSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-3 justify-center items-center gap-x-3">
                <div>
                  <TextField
                    label="First Name"
                    name="fname"
                    placeholder="First Name"
                    formik={formik}
                    disabled={!asPresonalInfoEdit}
                  />
                </div>
                <div>
                  <TextField
                    label="Last Name"
                    name="lname"
                    placeholder="Last Name"
                    formik={formik}
                    disabled={!asPresonalInfoEdit}
                  />
                </div>
                <div>
                  {asPresonalInfoEdit ? (
                    <CountryField
                      label=" Country of Residence"
                      name="country"
                      placeholder="Saudi Arabia"
                      formik={formik}
                      disabled={!asPresonalInfoEdit}
                    />
                  ) : (
                    <TextField
                      label=" Country of Residence"
                      name="country"
                      placeholder="Saudi Arabia"
                      formik={formik}
                      disabled={!asPresonalInfoEdit}
                    />
                  )}
                </div>
              </div>
              <div className="py-2 font-imprima text-lg">
                <div className="flex items-center text-info gap-x-4">
                  <label>Gender</label>
                  <div className="space-x-1">
                    <input
                      type="radio"
                      name="gender"
                      id="male"
                      value="Male"
                      disabled={!asPresonalInfoEdit}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="border-2 border-black checked:bg-black checked:ring-black"
                      checked={formik?.values?.gender === "Male"}
                    />
                    <label htmlFor="male">Male</label>
                  </div>
                  <div className=" space-x-3">
                    <input
                      type="radio"
                      name="gender"
                      id="female"
                      value="Female"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className="border-2 border-black checked:bg-black checked:ring-black"
                      checked={formik?.values?.gender === "Female"}
                      disabled={!asPresonalInfoEdit}
                    />
                    <label htmlFor="female">Female</label>
                  </div>
                </div>
                {formik.touched.gender && formik.errors.gender && (
                  <div className=" pt-3 text-[12px] text-red-600 font-imprima">
                    {formik.errors.gender}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
